export const SETFILTERCUSTOMERLIST = "SETFILTERCUSTOMERLIST";
export const SETFILTEROPPSTAGE = "SETFILTEROPPSTAGE";
export const SETFILTEREMPRESP = "SETFILTEREMPRESP";
export const SETOPPLIST = "SETOPPLIST";
export const SETFOLLOWUPHISTORYLIST = "SETFOLLOWUPHISTORYLIST";
export const SETVERTICALLIST = "SETVERTICALLIST";
export const SETSOURCELIST = "SETSOURCELIST";
export const SETCUSTOMERLIST = "SETCUSTOMERLIST";
export const SETOPPORTUNITY = "SETOPPORTUNITY";
export const SETATTACHMENTLIST = "SETATTACHMENTLIST";
export const CLEARDOC = "CLEARDOC";
export const SETADVANCEFILTERLIST = "SETADVANCEFILTERLIST";
export const SETCUSTOMERDETAILS = "SETCUSTOMERDETAILS";
export const SETSTATUSLIST = "SETSTATUSLIST";
export const SETADDITIONALSTATELIST = "SETADDITIONALSTATELIST";
export const SETTASKLIST = "SETTASKLIST";
export const SETOPPORTUNITYBASICFILTERDATA = "SETOPPORTUNITYBASICFILTERDATA";